import { render, staticRenderFns } from "./ActivityPageEdit.vue?vue&type=template&id=4f3bf7fe&scoped=true"
import script from "./ActivityPageEdit.vue?vue&type=script&lang=js"
export * from "./ActivityPageEdit.vue?vue&type=script&lang=js"
import style0 from "./ActivityPageEdit.vue?vue&type=style&index=0&id=4f3bf7fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3bf7fe",
  null
  
)

export default component.exports